import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../../../../common/redux/root.reducer'
import { mapOrderBody } from './mapOrderBody'
import { OrderConceptState } from '../types/types'
import Ajv from 'ajv'
import orderBodySchema from '../types/OrderBody.schema.json'
import { normalizeForComparison } from '../utils/normalizeForComparison'

const ajv = new Ajv()
const validate = ajv.compile(orderBodySchema)

export const selectOrderConceptState = (state: RootState): OrderConceptState =>
  state.orderConcept

export const validOrder = createSelector(
  selectOrderConceptState,
  ({ orderConcept }: OrderConceptState): boolean => {
    if (!orderConcept) return false
    const orderBody = mapOrderBody(orderConcept)
    return validate(orderBody)
  }
)

export const hasUnsavedChangesCreateOrder = createSelector(
  selectOrderConceptState,
  ({ orderConcept, originalOrderConcept }: OrderConceptState): boolean => {
    if (!originalOrderConcept) return false
    const normalizedCurrent = normalizeForComparison(orderConcept)
    const normalizedOriginal = normalizeForComparison(originalOrderConcept)
    return JSON.stringify(normalizedCurrent) !== JSON.stringify(normalizedOriginal)
  }
)
